import {
    useEditController,
    EditContextProvider,
    Form,
    SaveButton,
    useNotify,
    useRedirect,
    useTranslate,
    useRefresh,
} from 'react-admin';

import {
    DialogTitle,
    DialogContent,
    DialogActions,
    Button as MUIButton,
} from '@mui/material';

import { useFormContext } from 'react-hook-form';
import { Resources } from '../resource';
import SmartMoneyForm from './SmartMoneyForm';
import { PermissionButton } from 'src/routes/components/permission-button';

const EditMetadata = ({ id, onClose }: { id: string | number; onClose: () => void }) => {
    const notify = useNotify();
    const redirect = useRedirect();
    const t = useTranslate();
    const form = useFormContext();
    const refresh = useRefresh();

    const controller = useEditController({
        id,
        resource: Resources.smartMoney,
        mutationMode: 'pessimistic',
        mutationOptions: {
            onSuccess: () => {
                notify(t('module.smartMoney.updateSuccess'), { type: 'success' })
                refresh()
                onClose()
            },
            onError: (error: any) => {
                const errorCode = error?.body?.code || error?.code;
                switch (errorCode) {
                    case 'SMART_MONEY_ALREADY_EXISTS':
                        notify(t('module.smartMoney.validate.conflict'), { type: 'error' });
                        break;
                    case 'METADATA_INVALID':
                        notify(t('module.smartMoney.validate.metadataInvalid'), { type: 'error' });
                        break;
                    default:
                        notify(t('module.smartMoney.unknownErrorUpdate'), { type: 'error' });
                        break;
                }
            },
        },
    });

    if (controller.isLoading || !controller.record) return null;

    return (
        <EditContextProvider value={controller}>
            <Form disableInvalidFormNotification>
                <DialogTitle>{t('module.smartMoney.editSmartMoney')}</DialogTitle>
                <DialogContent>
                    <SmartMoneyForm isCreate={false} />
                </DialogContent>
                <DialogActions>
                    <MUIButton
                        variant="outlined"
                        onClick={() => {
                            onClose();
                        }}
                    >
                        {t('actions.cancel')}
                    </MUIButton>
                    <PermissionButton resource="smart-money" action="update">
                        <SaveButton />
                    </PermissionButton>
                </DialogActions>
            </Form>
        </EditContextProvider>
    );
};

export default EditMetadata;
